// src/components/Blogs/BlogDetail.jsx
// ✅ FINAL COMPLETE VERSION - React Router v5

import { useEffect } from "react";
import { useParams, useHistory } from "react-router-dom";
import { blogs } from "../../blogs";
import styles from "./BlogDetail.module.css";

const BlogDetail = () => {
  const { slug } = useParams();
  const history = useHistory();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);

  const blog = blogs.find((b) => b.slug === slug);

  if (!blog) {
    return (
      <div className={styles.container} style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "white",
        minHeight: "100vh",
        paddingTop: "60px"
      }}>
        <h2>Blog not found</h2>
      </div>
    );
  }

  const Component = blog.component;

  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        {/* Back Button */}
        <div style={{
          marginBottom: "2rem"
        }}>
          <button
            onClick={() => history.goBack()}
            style={{
              background: "none",
              border: "none",
              color: "#8b5cf6",
              cursor: "pointer",
              fontSize: "0.95rem",
              padding: "0.5rem 0",
              textDecoration: "none",
              fontWeight: "500",
              display: "flex",
              alignItems: "center",
              gap: "0.5rem",
              transition: "color 0.3s"
            }}
          >
            ← Back to Blogs
          </button>
        </div>

        {/* Blog Content - Date is already inside Component */}
        <article style={{
          color: "#e5e7eb"
        }}>
          <Component />
        </article>
      </div>
    </div>
  );
};

export default BlogDetail;